module.exports = {"singular":"Ticket","plural":"Tickets","price":"Preis","quota":"Kontingent","sold":"Verkauft","revenue":"Erlöse"};